<template>
  <!-- NOTE (TEMPLATE) to add reason for rejection  -->

  <div class="animated fadeIn">
    <b-card
      v-if="$router.currentRoute.path == '/admin/banners'"
      style="border: 0"
      class="mt-0 mb-0"
    >
      <b-button variant="success" @click="openAdd()" class="my-2"
        ><strong>افزودن بنر +</strong></b-button
      >
      <v-row class="header-box btn-radius pa-1 ps-2" style="margin: 0 1px 25px">
        <v-col>
          <h4 style="margin-top: 9px">مدیریت بنرها</h4>
        </v-col>
      </v-row>
      <h6>
        <b-input-group size="md">
          <b-form-input
            trim
            v-model="filter"
            type="search"
            id="filterInput"
            placeholder="جستجو"
          ></b-form-input>
          <b-input-group-append>
            <!-- NOTE (b-delete) to delete the text of the search bar -->
            <b-button :disabled="!filter" @click="filter = ''" variant="danger"
              >حذف</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </h6>

      <!-- NOTE (t-reasonList) to show reasons for rejecting proposal list -->
      <b-table
        responsive
        small
        show-empty
        head-variant="dark"
        :fields="fields"
        :items="items"
        empty-text="هنوز بنری تعریف نشده است"
        striped
        :busy="isBusy"
        :filter="filter"
      >
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(operation)="data">
          <div style="text-align: center; vertical-align: middle">
            <b-btn variant="warning" @click="openEdit(data.item)">ویرایش</b-btn>
            <b-btn variant="danger" @click="openDelete(data.item)">حذف</b-btn>
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 }}
          </div>
        </template>
        <div slot="table-busy" class="text-center tableDarkText my-2">
          <strong>در حال بارگذاری...</strong>
          <br />
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </b-table>
    </b-card>
    <br />
    <router-view></router-view>
    <b-modal id="addBanner" ref="addBanner">
      <h4>افزودن بنر جدید</h4>
      <br />
      <b-form-group>
        <b-form-input
          trim
          placeholder="عنوان بنر"
          v-model="title"
        ></b-form-input>
      </b-form-group>
      <b-form-group>
        <b-form-input trim placeholder="آدرس rfp" v-model="url"></b-form-input>
      </b-form-group>
      <b-form-group label="عنوان طرح کلان">
        <b-form-select
          :options="
            uniRequests.map((x) => {
              return {
                value: x.id,
                text: `${x.faSubject} (${x.university})`,
              };
            })
          "
          v-model="uniRequestId"
        ></b-form-select>
      </b-form-group>
      <b-form-group
        label="تصویر بنر"
        class="my-3"
        :class="Object.keys(bannerFileData).length ? 'done' : ''"
      >
        <b-form-file
          :state="Boolean(Object.keys(bannerFileData).length)"
          :disabled="Boolean(Object.keys(bannerFileData).length)"
          @input="finalBannerUploadFile(bannerFile)"
          v-model="bannerFile"
          browse-text="بارگذاری"
          :placeholder="
            bannerFileData
              ? bannerFileData.name
              : 'فایل مربوطه را بارگذاری کنید (حداکثر 20 مگابایت)'
          "
        ></b-form-file>

        <b-col>
          <b-progress
            v-if="bannerFileData.showProgress"
            :value="bannerFileData.uploadPercentage"
            :max="max"
            show-progress
            :animated="bannerFileData.striped"
            :variant="bannerFileData.variant"
          ></b-progress>
          <br />
          <b-row>
            <b-col>
              <div
                style="color: green"
                v-if="bannerFileData.isUploaded"
                color="green"
              >
                فایل جدید با موفقیت آپلود شد.
              </div>
            </b-col>
            <b-col>
              <b-row align-h="end" v-if="Object.keys(bannerFileData).length">
                <span class="mt-3 ml-2" style="float: left"
                  ><a
                    class="btn btn-success white--text"
                    :href="bannerFileData.url"
                    target="_blank"
                    >دریافت</a
                  ></span
                >
                <b-button
                  style="height: 35px; float: left"
                  class="btn ml-2 mt-3"
                  variant="danger"
                  @click="
                    bannerFile = null;
                    bannerFileData = {};
                  "
                  >حذف</b-button
                >
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-form-group>
      <template v-slot:modal-footer>
        <b-btn
          :disabled="!title || !uniRequestId || !bannerFileData.url"
          variant="success"
          @click="addBanner()"
          >افزودن</b-btn
        >
      </template>
    </b-modal>
    <b-modal id="editBanner" ref="editBanner">
      <h4>ویرایش بنر</h4>
      <br />
      <b-form-group>
        <b-form-input
          trim
          placeholder="عنوان بنر"
          v-model="banner.title"
        ></b-form-input>
      </b-form-group>
      <b-form-group>
        <b-form-input
          trim
          placeholder="آدرس rfp"
          v-model="banner.url"
        ></b-form-input>
      </b-form-group>
      <b-form-group label="عنوان طرح کلان">
        <b-form-select
          :options="
            uniRequests.map((x) => {
              return {
                value: x.id,
                text: `${x.faSubject} (${x.university})`,
              };
            })
          "
          v-model="banner.uniRequestId"
        ></b-form-select>
      </b-form-group>
      <b-form-group
        label="تصویر بنر"
        class="my-3"
        :class="Object.keys(bannerFileData).length ? 'done' : ''"
      >
        <b-form-file
          :state="Boolean(Object.keys(bannerFileData).length)"
          :disabled="Boolean(Object.keys(bannerFileData).length)"
          @input="finalBannerUploadFile(bannerFile)"
          v-model="bannerFile"
          browse-text="بارگذاری"
          :placeholder="
            bannerFileData
              ? bannerFileData.name
              : 'فایل مربوطه را بارگذاری کنید (حداکثر 20 مگابایت)'
          "
        ></b-form-file>

        <b-col>
          <b-progress
            v-if="bannerFileData.showProgress"
            :value="bannerFileData.uploadPercentage"
            :max="max"
            show-progress
            :animated="bannerFileData.striped"
            :variant="bannerFileData.variant"
          ></b-progress>
          <br />
          <b-row>
            <b-col>
              <div
                style="color: green"
                v-if="bannerFileData.isUploaded"
                color="green"
              >
                فایل جدید با موفقیت آپلود شد.
              </div>
            </b-col>
            <b-col>
              <b-row align-h="end" v-if="Object.keys(bannerFileData).length">
                <span class="mt-3 ml-2" style="float: left"
                  ><a
                    class="btn btn-success white--text"
                    :href="bannerFileData.url"
                    target="_blank"
                    >دریافت</a
                  ></span
                >
                <b-button
                  style="height: 35px; float: left"
                  class="btn ml-2 mt-3"
                  variant="danger"
                  @click="
                    bannerFile = null;
                    bannerFileData = {};
                  "
                  >حذف</b-button
                >
              </b-row>
              <b-row align-h="end" v-else-if="banner.imageUrl">
                <span class="mt-3 ml-2" style="float: left"
                  ><a
                    class="btn btn-success white--text"
                    :href="banner.imageUrl"
                    target="_blank"
                    >دریافت</a
                  ></span
                >
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-form-group>
      <template v-slot:modal-footer>
        <!-- NOTE (b-editRasteh2) previous -->
        <b-button
          :disabled="
            !banner.title ||
            !banner.uniRequestId ||
            !(bannerFileData.url || banner.imageUrl)
          "
          variant="success"
          @click="editBanner()"
          >ثبت تغییرات</b-button
        >
      </template>
    </b-modal>
    <b-modal id="deleteBanner" ref="deleteBanner">
      شما در حال حذف این بنر هستید:
      <br />
      <strong>{{ selected.title }}</strong>
      <br />آیا مطمئن هستید؟
      <template v-slot:modal-footer>
        <!-- NOTE (b-deleteReason2) previous -->
        <b-button
          variant="danger"
          @click="deleteBanner()"
          :disabled="submitBusy"
          >بله</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  components: {},
  data: function () {
    return {
      fields: [
        { key: "index", label: "ترتیب" },
        { key: "title", label: "عنوان" },
        { key: "uniRequestTitle", label: "عنوان طرح کلان" },
        { key: "university", label: "دانشگاه" },
        { key: "active", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      items: [],
      filter: "",
      isBusy: true,
      submitBusy: false,
      selected: {},
      banner: {},
      title: "",
      url: "",
      uniRequestId: "",
      bannerFile: [],
      bannerFileData: {},
      uniRequests: [],
    };
  },

  methods: {
    getData() {
      this.isBusy = true;
      this.$http
        .get(this.baseUrl + "/setad/admin/banners/", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.items = res.data;
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            else
              this.$router.push({
                path: "/unauthorize",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    getBannerData() {
      this.isBusy = true;
      this.$http
        .get(this.baseUrl + "/setad/admin/banner/" + this.selected.id, {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.banner = res.data;
          this.isBusy = false;
        })
        .catch((err) => {
          this.isBusy = false;
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            else
              this.$router.push({
                path: "/unauthorize",
                query: { return: window.location.pathname },
              });
          }
        });
    },

    addBanner() {
      this.submitBusy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/banner/",
          {
            title: this.title,
            url: this.url,
            uniRequestId: this.uniRequestId,
            imageId: this.bannerFileData ? this.bannerFileData.id : undefined,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          this.submitBusy = false;
          this.newTitle = "";
          this.uniRequestId = "";
          this.bannerFile = [];
          this.bannerFileData = {};
          this.getData();
          this.$refs["addBanner"].hide();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.submitBusy = false;
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            else
              this.$router.push({
                path: "/unauthorize",
                query: { return: window.location.pathname },
              });
          }
        });
    },

    openAdd() {
      // NOTE (m-openAdd1) to show loading
      this.getUniRequests();
      this.$refs["addBanner"].show();
    },
    openEdit(item) {
      this.getUniRequests();
      this.selected = item;
      this.getBannerData();
      this.$refs["editBanner"].show();
    },
    openDelete(item) {
      this.selected = item;
      this.$refs["deleteBanner"].show();
    },

    editBanner() {
      this.$http
        .patch(
          this.baseUrl + "/setad/admin/banner/" + this.selected.id,
          {
            title: this.banner.title,
            url: this.banner.url,
            uniRequestId: this.banner.uniRequestId,
            imageId: this.bannerFileData
              ? this.bannerFileData.id
              : this.banner.imageId,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          this.selected = {};
          this.bannerFile = [];
          this.bannerFileData = {};
          this.getData();
          this.$refs["editBanner"].hide();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.submitBusy = false;
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            else
              this.$router.push({
                path: "/unauthorize",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    deleteBanner() {
      this.$http
        .delete(this.baseUrl + "/setad/admin/banner/" + this.selected.id, {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.toast(res.data, "success");
          this.getData();
          this.$refs["deleteBanner"].hide();
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.submitBusy = false;
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            else
              this.$router.push({
                path: "/unauthorize",
                query: { return: window.location.pathname },
              });
          }
        });
    },
    finalBannerUploadFile(file) {
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 15) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        this.bannerFileData.showProgress = true;
        this.bannerFileData.variant = "info";
        this.bannerFileData.uploadPercentage = 0;
        this.bannerFileData.isUploaded = false;
        this.bannerFileData.uploadButDisable = true;
        let formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(this.baseUrl + "/setad/admin/banner/upload/", formData, {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
            onUploadProgress: ((progressEvent) => {
              this.bannerFileData.uploadPercentage =
                Math.round((progressEvent.loaded * 100) / progressEvent.total) -
                1;
            }).bind(this),
          })
          .then((d) => {
            if (d.status == 200) {
              this.bannerFileData.isUploaded = true;
              this.bannerFileData.uploadPercentage = 100;
              this.bannerFileData.striped = false;
              this.bannerFileData.variant = "success";
              this.bannerFileData.uploadButDisable = false;
              this.bannerFileData = d.data;
              this.$forceUpdate();
              this.toast("فایل با موفقیت بارگذاری کردید.", "success");
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.bannerFile = null;
            this.bannerFileData.uploadPercentage = 0;
            this.bannerFileData.isUploaded = false;
          });
      }
    },
    getUniRequests() {
      this.isBusy = true;
      this.$http
        .get(this.baseUrl + "/setad/admin/uniRequests/finalize", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.uniRequests = res.data;
          this.isBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          if (err.response.status == 403) {
            if (err.response.data == "expired")
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
            // else this.$router.replace("/unauthorize");
            else
              this.$router.push({
                path: "/login",
                query: { return: window.location.pathname },
              });
          }
        });
    },
  },

  mounted() {
    this.getData();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
